import moment from "moment";

export const real = {
  format(value: number) {
    const absValue = Math.abs(value);
    const formatted = Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(absValue);
    if (value < 0) {
      // Move the minus sign after "R$"
      return formatted.replace(/^(-)?(R\$)\s?/, "$2 -");
    }
    return formatted;
  },
};

export function Loja(codigo: number) {
  if (codigo === 2) {
    return "002 - Benoliel Muca";
  }
  if (codigo === 300) {
    return "300 - Benoliel Trem";
  }
  return "003 - Benoliel Baby";
}

export function ShowCalculeValue(row: any) {
  const { juros, total } = row;

  const sup =
    juros > 0 ? (
      <sup style={{ color: "#dc3545" }}>
        +{real.format(juros).replace("R$", "")}
      </sup>
    ) : undefined;

  const component = (
    <div>
      {real.format(row.installmentValue).replace("R$", "")} {sup}
    </div>
  );

  return { total, juros, component };
}
